import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import store from './store';
import Home from './pages/Home';
import Shutdown from './pages/Shutdown';
import '@fontsource/montserrat/600.css'; /* Removed */

// We don't need @fontsource imports here because we load it in index.html

function App() {
  return (
    <Provider store={store}>
      <Router>
        <div className="App" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shutdown" element={<Shutdown />} />
          </Routes>
        </div>
      </Router>
    </Provider>
  );
}

export default App;
